(function () {
  if (typeof window === 'undefined') return;
  if (window.kottReduceMotion ? window.kottReduceMotion() : (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;

  var STORAGE_KEY = 'kott-circle-reveal-state';
  var EXPAND_MS   = 480;
  var SAFETY_MS   = 80;
  var overlay     = null;

  function getOverlay() {
    if (overlay && document.body.contains(overlay)) return overlay;
    overlay = document.getElementById('kott-circle-reveal');
    return overlay;
  }

  function isInternalNavLink(link, event) {
    if (!link || !link.getAttribute('href')) return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self' && link.target !== '') return false;
    if (link.hasAttribute('download')) return false;
    if (link.dataset.noCircleReveal === 'true') return false;
    if (link.closest('[data-no-circle-reveal]')) return false;

    var href = link.getAttribute('href');
    if (!href) return false;
    if (href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:|whatsapp:)/i.test(href)) return false;

    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return false; }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    if (url.origin !== window.location.origin) return false;

    // Same page + only a hash change — let the browser scroll, skip the overlay.
    if (url.pathname === window.location.pathname &&
        url.search === window.location.search &&
        url.hash) return false;

    // Same exact URL — refresh, skip.
    if (url.href === window.location.href) return false;

    return true;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  document.addEventListener('click', function (event) {
    if (document.documentElement.classList.contains('kott-loader-active')) return;

    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!isInternalNavLink(link, event)) return;

    var el = getOverlay();
    if (!el) return;

    event.preventDefault();

    var x = event.clientX;
    var y = event.clientY;
    if (!x && !y) {
      var rect = link.getBoundingClientRect();
      x = rect.left + rect.width  / 2;
      y = rect.top  + rect.height / 2;
    }
    x = clamp(x, 0, window.innerWidth);
    y = clamp(y, 0, window.innerHeight);

    el.style.setProperty('--kott-circle-cx', x + 'px');
    el.style.setProperty('--kott-circle-cy', y + 'px');
    el.classList.remove('is-held', 'is-contracting');
    void el.offsetWidth;
    el.classList.add('is-active', 'is-expanding');

    var navigated = false;
    var target    = link.href;

    function go() {
      if (navigated) return;
      navigated = true;
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ x: x, y: y, t: Date.now() }));
      } catch (_) {}
      window.location.href = target;
    }

    var onEnd = function (e) {
      if (e.animationName !== 'kott-circle-reveal-expand') return;
      el.removeEventListener('animationend', onEnd);
      go();
    };
    el.addEventListener('animationend', onEnd);
    setTimeout(go, EXPAND_MS + SAFETY_MS);
  }, { capture: true });

  // If the user comes back via bfcache, the overlay may still be visible — clear it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var el = getOverlay();
    if (el) el.classList.remove('is-active', 'is-expanding', 'is-held', 'is-contracting');
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
  });
})();
